import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    options: Object,
  };

  disconnect() {
    if (this.chart !== undefined) {
      this.chart.dispose();
      this.chart = null;
    }
  }

  ReorderBreakdownChart = () => {
    this.chart = window.echarts.init(document.getElementById('reorder-breakdown-chart'));
    const rb = this.optionsValue['reorder-breakdown'];
    const options = {
      tooltip: {
        trigger: 'item',
      },
      series: [
        {
          name: 'Order Statistics',
          type: 'pie',
          radius: ['50%', '90%'],
          right: '-4%',
          color: ['#00439D', '#006AF9', '#006AF9'],
          label: {
            show: false,
          },
          data: [
            { name: 'First Order', value: rb['first-order'] },
            { name: 'Reorder', value: rb['reorder'] },
          ],
        },
      ],
    };
    this.chart.setOption(options);
  };

  whenEchartsAvailable = () => {
    const interval = setInterval(() => {
      if (window.echarts !== undefined) {
        this.ReorderBreakdownChart();
        window.onresize = () => {
          if (this.chart !== null) {
            this.chart.resize();
          }
        };
        clearInterval(interval);
      }
    }, 10);
  };

  initialize() {
    this.whenEchartsAvailable();
  }
}
